import type { FormGroup } from '@angular/forms';
import { inject, Injectable } from '@angular/core';
import { FormBuilder, AbstractControl, ValidationErrors } from '@angular/forms';
import { FIELD_TEXT_REQUIRED, FormValidator } from '@shared/reactive-forms/form-fields-validate.helper';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordBuildFormService {
  private readonly formBuilder = inject(FormBuilder);

  /**
   * Validador personalizado para verificar que las contraseñas coincidan.
   */
  private passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const newPassword = control.get('newPassword')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;

    if (!newPassword || !confirmPassword) return null;

    return newPassword === confirmPassword ? null : { passwordMismatch: true };
  }

  /**
   * Construye y retorna un formulario de restablecimiento de contraseña.
   */
  public buildResetPasswordForm(): FormGroup {
    return this.formBuilder.group(
      {
        newPassword: FormValidator.requiredMinLength(FIELD_TEXT_REQUIRED),
        confirmPassword: FormValidator.requiredMinLength(FIELD_TEXT_REQUIRED),
      }, {
        validators: this.passwordMatchValidator.bind(this),
      }
    );
  }
}
